// La etiqueta se resuelve con dt('costCenter.colors.<key>') en el consumidor:
// este array se evalúa al importar, antes de que el idioma pueda cambiar.
export const COST_CENTER_COLORS = [
  { key: 'black', hex: '#1f2937' },
  { key: 'amber', hex: '#ffa000' },
  { key: 'blue', hex: '#1976d2' },
  { key: 'brown', hex: '#795548' },
  { key: 'green', hex: '#388e3c' },
  { key: 'grey', hex: '#616161' },
  { key: 'olive', hex: '#6d8c3e' },
  { key: 'orange', hex: '#f57c00' },
  { key: 'pink', hex: '#c2185b' },
  { key: 'purple', hex: '#7b1fa2' },
  { key: 'red', hex: '#d32f2f' },
  { key: 'teal', hex: '#00897b' },
  { key: 'violet', hex: '#5e35b1' },
  { key: 'yellow', hex: '#f9a825' },
];

export const DEFAULT_COST_CENTER_COLOR = '#1f2937';
export const DEFAULT_COST_CENTER_ICON = 'tag';

export const COST_CENTER_ICONS = [
  'activity', 'archive', 'award', 'bar-chart-2', 'book', 'briefcase', 'box',
  'calendar', 'camera', 'clipboard', 'clock', 'cloud', 'code', 'coffee', 'compass',
  'cpu', 'credit-card', 'database', 'disc', 'dollar-sign', 'download', 'edit', 'file',
  'film', 'flag', 'folder', 'gift', 'globe', 'grid', 'hard-drive', 'headphones', 'heart',
  'home', 'image', 'inbox', 'layers', 'layout', 'life-buoy', 'link', 'list', 'lock',
  'mail', 'map', 'map-pin', 'monitor', 'music', 'package', 'paperclip', 'percent',
  'phone', 'pie-chart', 'printer', 'refresh-cw', 'save', 'search', 'server', 'settings',
  'shield', 'shopping-bag', 'shopping-cart', 'smartphone', 'star', 'sun', 'tag',
  'target', 'tool', 'truck', 'tv', 'umbrella', 'user', 'users', 'video', 'watch',
  'wifi', 'zap',
];

const HEX6 = /^#([0-9a-f]{6})$/i;
const HEX3 = /^#([0-9a-f]{3})$/i;

function expandHex(raw) {
  const v = String(raw ?? '').trim();
  if (HEX6.test(v)) return v.toLowerCase();
  const m = v.match(HEX3);
  if (m) {
    const [r, g, b] = m[1].split('');
    return `#${r}${r}${g}${g}${b}${b}`.toLowerCase();
  }
  return null;
}

export function parseCostCenterHex(value) {
  return expandHex(value) || DEFAULT_COST_CENTER_COLOR;
}

const COLOR_BY_HEX = Object.fromEntries(
  COST_CENTER_COLORS.map((c) => [c.hex.toLowerCase(), c]),
);

export const getCostCenterColorTokens = (hexValue) => {
  const hex = parseCostCenterHex(hexValue);
  const preset = COLOR_BY_HEX[hex.toLowerCase()];
  return {
    hex,
    label: preset?.label ?? 'Personalizado',
  };
};

export const costCenterTint = (hexValue, alpha = 0.16) => {
  const hex = parseCostCenterHex(hexValue).replace('#', '');
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const CostCenterColorOption = ({ label, hex }) => (
  <span className="cost-center-color-option">
    <span className="cost-center-color-option__swatch" style={{ backgroundColor: hex }} aria-hidden />
    <span>{label}</span>
  </span>
);
